module.exports = __webpack_public_path__ + "img/CALENDER.a6f79f12.svg";